import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    user: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ""
}

export const LoginUser = createAsyncThunk("user/LoginUser", async(user, thunkAPI) => {
    try {
        const apiUrl = process.env.REACT_APP_URL_API;
        const response = await axios.post(`${apiUrl}/login`, {
            username: user.username,
            password: user.password
        });
        // Store token in localStorage
        if (response.data.accessToken) {
            localStorage.setItem('accessToken', response.data.accessToken);
        }
        return response.data;
    } catch (error) {
        if (error.response){
            const message = error.response.data.msg;
            return thunkAPI.rejectWithValue(message);
        }
    }
});

export const getMe = createAsyncThunk("user/getMe", async(_, thunkAPI) => {
    try {
        const token = localStorage.getItem('accessToken');
        const apiUrl = process.env.REACT_APP_URL_API;
        const response = await axios.get(`${apiUrl}/me`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response){
            const message = error.response.data.msg;
            return thunkAPI.rejectWithValue(message);
        }
    }
});

export const LogOut = createAsyncThunk("user/LogOut", async(_, thunkAPI) => {
    try {
        const token = localStorage.getItem("accessToken");
        const apiUrl = process.env.REACT_APP_URL_API;
        await axios.delete(`${apiUrl}/logout`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        // Remove token from localStorage
        localStorage.removeItem('accessToken');
    } catch (error) {
        return thunkAPI.rejectWithValue("Logout failed");
    }
});

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers:{
        reset: (state) => {
            return {
                ...initialState,
                user: state.user // Preserve user data during reset
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(LoginUser.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(LoginUser.fulfilled, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.user = action.payload
            state.isError = false; // Explicitly reset error state
            state.message = ""; // Clear any error messages
        })
        builder.addCase(LoginUser.rejected, (state, action) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload
        })

        //Get User Login
        builder.addCase(getMe.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(getMe.fulfilled, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.user = action.payload
        })
        builder.addCase(getMe.rejected, (state, action) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload
        })

        builder.addCase(LogOut.fulfilled, (state) => {
            state.user = null;
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.message = "";
          })
    }
})

export const {reset} = authSlice.actions
export default authSlice.reducer